export enum MoodEnum {
    angry = 'angry',
    sad = 'sad',
    neutral = 'neutral',
    happy = 'happy',
    inLove = 'inLove',
}
